import React from 'react';
import { getBannerTargetWindow } from '../data/sport-utils';

function BetslipBanners(props) {
    const banners = props.banners;

    if (banners == null) {
        return null;
    }

    return (
        <>
            {banners.map((banner, i) => {
            	const key = "banner-" + banner.id;
	            return <div key={key} className="banner-widget-dx widget-betslip">
	                    <a href={banner.url} target={getBannerTargetWindow(banner.url)} rel="noopener noreferrer">
	                        <img src={banner.imageUrl} className="img-fluid margine-giu bordo-tondo" alt="" />
	                    </a>
	                </div>
	        }
            )}
        </>
    );
}

export default BetslipBanners;